import { useState } from 'react';
import { useOrganizationStore } from '../../stores/useOrganizationStore';
import { addContactsToFlow as addContactsToFlowApi } from '../../api/flows';

export interface AddContactsToFlowResult {
  success: boolean;
  created?: number;
  skipped_duplicate?: number;
  errors?: number;
  error?: string;
}

interface UseFlowContactsResult {
  addContactsToFlow: (flowId: string, tags: string[]) => Promise<AddContactsToFlowResult>;
  isAdding: boolean;
}

export const useFlowContacts = (): UseFlowContactsResult => {
  const [isAdding, setIsAdding] = useState(false);
  const { organization } = useOrganizationStore();

  const addContactsToFlow = async (flowId: string, tags: string[]): Promise<AddContactsToFlowResult> => {
    if (!organization?.id) {
      return {
        success: false,
        error: 'Organization ID is required',
      };
    }

    setIsAdding(true);
    try {
      const response = await addContactsToFlowApi(flowId, organization.id, tags);
      return {
        success: true,
        created: response?.created ?? 0,
        skipped_duplicate: response?.skipped_duplicate ?? 0,
        errors: response?.errors ?? 0,
      };
    } catch (error) {
      console.error('Error adding contacts to flow:', error);
      return {
        success: false,
        error: error instanceof Error ? error.message : 'Failed to add contacts',
      };
    } finally {
      setIsAdding(false);
    }
  };

  return {
    addContactsToFlow,
    isAdding,
  };
};
